module.exports = __webpack_public_path__ + "static/media/snowflake_4.32b5e756.png";